import { render } from "./WalletTransactionDetail.vue?vue&type=template&id=66c09eac&ts=true"
import script from "./WalletTransactionDetail.vue?vue&type=script&lang=ts"
export * from "./WalletTransactionDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__